import { connect, MapStateToProps } from "react-redux";

import { GridLayoutItemProps } from "@multiweb/reactComponents";
import { IAppState } from "@multiweb/types/react";
import { getVisibility } from "../../selectors";
import { GridLayoutMultiwebItemComponent, GridLayoutMultiwebItemComponentProps } from "../GridLayoutMultiwebItemComponent";

export type GridLayoutMultiwebItemProps = GridLayoutItemProps & {
    frameKey: string;
};

type StateProps = Pick<GridLayoutMultiwebItemComponentProps, "visible">;

const mapStateToProps: MapStateToProps<StateProps, GridLayoutMultiwebItemProps, IAppState> = (state, { frameKey }) => ({
    visible: getVisibility(state, frameKey),
});

export const GridLayoutMultiwebItem = connect(mapStateToProps)(GridLayoutMultiwebItemComponent);
